import storage from "local-storage-fallback";
import { privateClient } from "./client";

const fetchOfferEligibility = () =>
  privateClient.get(`/customers/${storage.getItem("identifier")}/loop/elegibility`);

const submitOfferSubscription = offerId =>
  privateClient.post(`/customers/${storage.getItem("identifier")}/loop/purchase`, {
    offer_id: offerId,
  });

export { fetchOfferEligibility, submitOfferSubscription };
